import { render, staticRenderFns } from "./GrantRegistryPerson.vue?vue&type=template&id=63ba75bb&scoped=true&"
import script from "./GrantRegistryPerson.vue?vue&type=script&lang=js&"
export * from "./GrantRegistryPerson.vue?vue&type=script&lang=js&"
import style0 from "./GrantRegistryPerson.vue?vue&type=style&index=0&id=63ba75bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ba75bb",
  null
  
)

export default component.exports